export enum ORDER_TYPES {
  DELIVERY = 'delivery',
  PICK_UP = 'pick_up',
  DINE_IN = 'dine_in',
  DRIVE_THRU = 'drive_thru',
}
